export enum ClientStatus {
    BLOCKED = 'BLOCKED',
    REGISTERED = 'REGISTERED',    
}
